module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-street-selected.b4d63c18.svg";